import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { I, Icon } from '../system/icons';
import { Eyebrow } from '../Eyebrow/Eyebrow';
import { Row } from '../server/layout/Row/index';
import { Stack } from '../server/layout/Stack/index';
import { TONE } from '../system/tone';
const SIZING = {
    page: { glyph: 64, glyphIcon: 26, titleFont: 'var(--type-title-sm)', bodyFont: 'var(--type-body)', padY: 'page', padX: '2xl', maxBody: 460, gap: 'lg' },
    compact: { glyph: 44, glyphIcon: 20, titleFont: 'var(--type-label)', bodyFont: 'var(--type-caption)', padY: 'xl', padX: 'lg', maxBody: 320, gap: 'md' },
    inset: { glyph: 56, glyphIcon: 24, titleFont: 'var(--type-title-sm)', bodyFont: 'var(--type-body)', padY: 'page', padX: '2xl', maxBody: 400, gap: 'lg' },
};
const isIconName = (v) => typeof v === 'string' && v in I;
export function EmptyState({ density = 'inset', tone = 'burgundy', icon, eyebrow, title, body, children, primary, secondary, actions, bordered = false, announce = false, style, className, }) {
    const sizing = SIZING[density];
    const t = TONE[tone];
    const iconNode = isIconName(icon) ? I[icon] : icon;
    const copy = body ?? children;
    const hasActions = primary || secondary || actions;
    return (_jsxs(Stack, { className: className, align: "center", gap: sizing.gap, px: sizing.padX, py: sizing.padY, ...(announce ? { role: 'status' } : {}), style: {
            textAlign: 'center',
            // `bordered` renders the one shared module surface (--surface-module-*)
            // so a bordered EmptyState matches every Card; borderless stays flat
            // for when it sits inside a surface that already owns the frame.
            borderRadius: bordered ? 'var(--surface-module-radius)' : 0,
            border: bordered ? 'var(--surface-module-border)' : 'none',
            boxShadow: bordered ? 'var(--surface-module-shadow)' : 'none',
            background: bordered ? 'var(--surface-module-bg)' : 'transparent',
            ...style,
        }, children: [_jsx("div", { style: {
                    width: sizing.glyph,
                    height: sizing.glyph,
                    borderRadius: 'var(--radius-full)',
                    background: t.bg,
                    color: t.ink,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                }, children: _jsx(Icon, { size: sizing.glyphIcon, children: iconNode }) }), _jsxs(Stack, { gap: "sm", align: "center", style: { maxWidth: sizing.maxBody }, children: [eyebrow ? _jsx(Eyebrow, { children: eyebrow }) : null, _jsx("h2", { style: {
                            font: sizing.titleFont,
                            margin: 0,
                            letterSpacing: '-0.005em',
                            textWrap: 'pretty',
                        }, children: title }), copy ? (_jsx("span", { style: {
                            font: sizing.bodyFont,
                            color: 'var(--muted-foreground)',
                            lineHeight: 1.6,
                            textWrap: 'pretty',
                        }, children: copy })) : null] }), hasActions ? (_jsxs(Row, { gap: "sm", justify: "center", wrap: true, mt: "xs", style: { rowGap: 'var(--space-sm)' }, children: [primary, secondary, actions] })) : null] }));
}
//# sourceMappingURL=EmptyState.js.map